let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7v6wU"), load("a8heY"), load("b544F"), load("9PPH7"), load("dzIm8"), load("hrf1M")]).then(() => parcelRequire('a9HoB'));